import React, { Fragment } from 'react';
import { filter, some, map, reduce } from 'lodash';
import pt from 'prop-types';

import { classNames, singularize } from 'utils';
import { productThumbUrl } from 'utils/product';

import Icon from 'components/icon';
import { Field } from 'components/form';
import { FadeIn } from 'components/transitions';

import './lookup-generic.scss';

const LOOKUP_QUERIES = Object.freeze({
  products: {
    fields: 'name, images',
  },
  categories: {
    fields: 'name, images',
  },
});

export default class LookupGeneric extends React.PureComponent {
  static propTypes = {
    label: pt.string,
    field: pt.object,
    onChange: pt.func,
    lookup: pt.object,
    value: pt.array,
  };

  getLookupQueries(models) {
    return reduce(models, (acc, cur) => (acc[cur] = LOOKUP_QUERIES[cur]), {});
  }

  renderFinderItems({ lookup, valueIndex, ...props }) {
    return lookup.results.map((record) => (
      <li
        key={record.id}
        role="option"
        data-id={record.id}
        aria-selected={record.id === props.selected?.id}
        className={classNames('item form-lookup-generic-item', {
          selected: record.id === props.selected?.id,
        })}
        onMouseOver={props.onMouseOver}
        onFocus={props.onMouseOver}
        onClick={props.onClick}
      >
        <span className="col">
          <FadeIn
            className="check"
            transitionAppear={false}
            active={valueIndex[record.id]}
          >
            <Icon fa="check" />
          </FadeIn>

          <span className="image">
            <img alt={record.name} src={productThumbUrl(record)} />
          </span>

          {record.name}
        </span>

        <span className="col muted text-right text-capitalize">
          {singularize(record._model)}
        </span>
      </li>
    ));
  }

  onSelectValue(value, selected, onChange) {
    if (!value) {
      onChange([selected]);
    }

    const exists = some(value, (valueItem) => valueItem.id === selected.id);

    if (value && !exists) {
      onChange([...value, selected]);
    } else if (value && exists) {
      onChange(filter(value, (valueItem) => valueItem.id !== selected.id));
    }
  }

  render() {
    const { label, field, onChange, lookup, value } = this.props;

    return (
      <Fragment>
        <Field
          type="finder"
          name="find-items"
          placeholder={field.placeholder || 'Pick items'}
          models={field.models}
          queries={this.getLookupQueries(field.models)}
          renderLookupItems={this.renderFinderItems}
          lookup={lookup}
          defaultValue={value}
          label={label}
          required={field.required ?? false}
          onSelectValue={(selected) =>
            this.onSelectValue(value, selected, onChange)
          }
        />

        <ul className="LookupGeneric-list">
          {map(value, (item, index) => (
            <li
              key={item.id}
              className={classNames({
                first: index === 0,
                last: index === value.length - 1,
              })}
            >
              <span className="LookupGeneric-list-title">{item.name}</span>

              <span className="LookupGeneric-list-title-label text-capitalize">
                {singularize(item._model)}
              </span>

              <button
                aria-label="Close"
                className="LookupGeneric-close"
                onClick={() => this.onSelectValue(value, item, onChange)}
                type="button"
              />
            </li>
          ))}
        </ul>
      </Fragment>
    );
  }
}
